import type { RouteLocationNormalized, RouteLocationRaw } from "vue-router";

export const buildNotFoundTarget = (to: RouteLocationNormalized, isValidLocale = true): RouteLocationRaw => {
  const segments = to.path.split("/").filter(Boolean);
  let locale = to.params.locale as string | undefined;

  if (locale && segments[0] === locale) {
    segments.shift();
  }

  if (!isValidLocale) {
    locale = undefined;
  }

  return {
    name: isValidLocale ? "NotFoundLocale" : "",
    params: {
      locale: locale,
      pathMatch: segments,
    },
    query: to.query,
    hash: to.hash,
  };
};
